module.exports = __webpack_public_path__ + "img/NEU-alt.2d4ac434.svg";